import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsSubscriptSvg } from './WpsSubscriptSvg'

export const WpsSubscriptIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={WpsSubscriptSvg} {...props} />
)
